import tw, { styled } from 'twin.macro'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import classNames from 'classnames'
import Content from '../components/Content'

const Container = styled('div')`
  ${tw`container mx-auto md:flex w-full p-12`}
`

const TableOfContents = styled('div')`
  ${tw`md:static md:w-1/4 bg-white md:bg-transparent p-4 md:p-0 mb-6`}

  ${props => props.collapsed ? tw`hidden md:block` : ''}

  a {
    ${tw`block text-gray-900 leading-readable`}
  }
`

const HamburgerLink = styled('a')`
  ${tw`block mx-4 mb-4 md:hidden`}
`

const SectionWrapper = styled('div')`
  ${tw`mb-8`}

  .active {
    ${tw`font-bold`}
  }

  a {
    ${tw`truncate`}
  }
`

const SectionHeading = styled('h2')`
  ${tw`uppercase text-base text-gray-600 mb-2`}
`

const Wrapper = styled('div')`
  ${tw`bg-white rounded-lg p-6 prose prose-sm sm:prose lg:prose-lg lg:max-w-none`}

  ${props => props.hasSections ? tw`w-full md:w-3/4` : `w-full`}
`

const Heading = styled('h1')`
  ${tw`text-5xl my-8 text-center text-gray-900`}
`

class GuidePostTemplate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tocCollapsed: true
    }
  }

  render() {
    const PostContent = this.props.contentComponent || Content;
    const hasSections = this.props.guidesBySection && this.props.guidesBySection.length > 0;

    return (
      <div tw="bg-gray-50">
        <Container>
        {hasSections && this.renderHamburger()}
          {hasSections && this.renderTOC()}
          <Wrapper hasSections={hasSections}>
            <Heading>{this.props.title}</Heading>
            <PostContent content={this.props.content} />
          </Wrapper>
        </Container>
      </div>
    )
  }


  renderHamburger() {
    const iconClasses = classNames('fa', {
      'fa-chevron-down': this.state.tocCollapsed,
      'fa-chevron-up': !this.state.tocCollapsed
    });

    return (
      <HamburgerLink href="#" onClick={this.handleHamburgerClicked}>
        <i className={iconClasses} /> Table of Contents
      </HamburgerLink>
    )
  }

  handleHamburgerClicked = e => {
    e.preventDefault();

    this.setState({
      tocCollapsed: !this.state.tocCollapsed
    });
  }

  renderTOC() {
    return (
      <TableOfContents collapsed={this.state.tocCollapsed}>
        {this.props.guidesBySection.map(section => (
          <SectionWrapper key={section.name}>
            <SectionHeading>{section.name}</SectionHeading>
            {section.guides.map(guide => (
              <Link key={guide.slug} to={guide.slug} className={this.slugIsCurrentPage(guide.slug) ? 'active' : ''} title={guide.title}>{guide.title}</Link>
            ))}
          </SectionWrapper>
        ))}
      </TableOfContents>
    );
  }

  slugIsCurrentPage(slug) {
    const path = typeof window !== 'undefined' ? window.location.pathname : '';

    return path === slug;
  }

}

GuidePostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  section: PropTypes.string,
  guidesBySection: PropTypes.array,
  title: PropTypes.string,
}

export default GuidePostTemplate;
